import React, { useEffect, useState } from "react";
import { getApiData } from "../../services/index";
import { Link } from "react-router-dom";
import referFriend from "../../assets/referFriend.png";
import "./index.css";
import GetInTouch from "../Home/GetInTouch/GetInTouch";
import Faq from "../Courses/FAQ";

const ReferFriend = () => {
  const [friends, setFriends] = useState([{}]); // Initialize with one friend object

  const handleAddFriend = () => {
    setFriends([...friends, {}]); // Add an empty friend object to the list
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedFriends = [...friends];
    updatedFriends[index] = {
      ...updatedFriends[index],
      [name]: value,
    };
    setFriends(updatedFriends);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(friends); // Handle form submission here
  };

   const [faqs, setFaqs] = useState([]);
      
        const checkData = () => {
          const app = { slug: "ReferFriend" };
          getApiData("api/get_faq", app).then((result) => {
            if (result && result["status"] === 200) {
              // Filter FAQs where slug is equal to "ReferFriend"
              const filteredFaqs = result["data"].filter(
                (faq) => faq.slug === "ReferFriend"
              );
              setFaqs(filteredFaqs);
            }
          });
        };
      
        useEffect(() => {
          checkData();
        }, []);

  return (
    <>
      <div class="section">
        <div class="container services">
          <div class="page-grid">
            <div
              id="w-node-_78a8848c-b0d2-b571-b6c9-efe0422fa0f2-4b337bc0"
              class="sidebar"
            >
              <div className="foorer-list">
                <div className="footer-title">Resources</div>
                <div className="w-dyn-list">
                  <div role="list" className="w-dyn-items">
                    <div role="listitem" className="w-dyn-item">
                      <Link
                        to="/blog"
                        className="footer-link-main w-inline-block"
                      >
                        <div>Blogs</div>
                      </Link>
                    </div>
                    <div role="listitem" className="w-dyn-item">
                      <Link
                        to="/ReferFriend"
                        className="footer-link-main w-inline-block"
                      >
                        <div>Refer a Friend</div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="margin-50px"></div>
            </div>
            <div
              id="w-node-_55e1e50e-c8b8-b242-e39a-50ea90d98b40-4b337bc0"
              class=""
            >
              <div className="header-content">
                <div>
                  <img loading="lazy" width="70" alt="" src={referFriend} />
                </div>
                <div className="margin-30px">
                  <h1 className="display-2">Refer a Friend</h1>
                </div>
                <div className="margin-20px">
                  <p className="subhead">
                    Refer a Friend & Earn Up to <strong>$500*</strong>
                  </p>
                </div>
              </div>

              <div className="service-page-wrapper w-richtext">
                <p>
                  Take advantage of this exciting opportunity to earn rewards
                  while helping your friends and family benefit from our
                  education & immigration services. Refer someone, and you could
                  earn up to <strong>$500*</strong>.
                </p>
                <p>
                  Simply fill in your details and your friend’s details, and
                  we’ll take care of the rest!
                </p>

                <h2>How It Works</h2>
                <ul role="list">
                  <li>
                    <strong>Refer Your Friend</strong> – Share their details
                    with us using the form below.
                  </li>
                  <li>
                    <strong>They Enroll or Use Our Services</strong> – Your
                    referral must successfully sign up and complete full
                    payment.
                  </li>
                  <li>
                    <strong>Get Rewarded</strong> – Receive up to{" "}
                    <strong>$500*</strong> after 30 days of service payment.
                  </li>
                </ul>

                <p>
                  📌 <strong>Note:</strong> Referral incentives vary based on
                  the service. The referral incentive is only processed after
                  full payment by the referred person.
                </p>

                <h3>Start Referring & Earning Today!</h3>

                <hr />

                <h2>Referral Form</h2>

                <div className="form-section max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
                  <h3 className="text-2xl font-semibold mb-4">Your Details</h3>
                  <form className="space-y-6" onSubmit={handleSubmit}>
                    {/* Your Details Section */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Name
                      </label>
                      <input
                        type="text"
                        name="your-name"
                        required
                        className="w-full p-3 mt-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />

                      <label className="block text-sm font-medium text-gray-700 mt-4">
                        Email
                      </label>
                      <input
                        type="email"
                        name="your-email"
                        required
                        className="w-full p-3 mt-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />

                      <label className="block text-sm font-medium text-gray-700 mt-4">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="your-phone"
                        required
                        className="w-full p-3 mt-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    {/* Friend's Details Section */}
                    {friends.map((friend, index) => (
                      <div
                        key={index}
                        className="friend-details space-y-4 mt-8 p-4 bg-gray-50 rounded-lg shadow-inner"
                      >
                        <h3 className="text-xl font-semibold text-blue-600">
                          Friend’s Details{" "}
                          {friends.length > 1 ? `#${index + 1}` : ""}
                        </h3>

                        <label className="block text-sm font-medium text-gray-700 mt-2">
                          Name
                        </label>
                        <input
                          type="text"
                          name="friend-name"
                          value={friend["friend-name"] || ""}
                          onChange={(e) => handleInputChange(e, index)}
                          required
                          className="w-full p-3 mt-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />

                        <label className="block text-sm font-medium text-gray-700 mt-4">
                          Email
                        </label>
                        <input
                          type="email"
                          name="friend-email"
                          value={friend["friend-email"] || ""}
                          onChange={(e) => handleInputChange(e, index)}
                          required
                          className="w-full p-3 mt-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />

                        <label className="block text-sm font-medium text-gray-700 mt-4">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          name="friend-phone"
                          value={friend["friend-phone"] || ""}
                          onChange={(e) => handleInputChange(e, index)}
                          required
                          className="w-full p-3 mt-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    ))}

                    {/* Add More Friends Button */}
                    <button
                      type="button"
                      onClick={handleAddFriend}
                      className="w-full py-3 mt-6 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 btn"
                    >
                      ➕ Add More Friends
                    </button>

                    {/* Submit Button */}
                    <button
                      type="submit"
                      className="w-full py-3 mt-6 bg-green-500 text-white rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 btn"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <Faq faqs={faqs} />

      <GetInTouch />
    </>
  );
};

export default ReferFriend;
